var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left p-1"},[_c('span',{staticClass:"mr-3"},[_vm._v(_vm._s(_vm.displayName(_vm.varItem)))]),_c('setter',{attrs:{"var-item":_vm.varItem}}),_c('hr')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }